import { formatDatetime } from '@/utils/date';
import CommonListingMapper from '@/components/features/listing-search/mappers/listing';
import { MapBoundsProperty } from '@/components/maps/enums';

const DEFAULT_PERCENTAGE = 100;

class ListingsMapper {
  static mapListingsData(listings) {
    return listings.map((listing) => {
      const mappedListing = CommonListingMapper.mapFromDto(listing);

      return ({
        ...mappedListing,
        year: this.#getFormattedDate(listing.closedAt, 'YYYY'),
        month: this.#getFormattedDate(listing.closedAt, 'MMMM'),
        baths: listing.halfBaths + listing.fullBaths,
        soldListRatio: this.#getAverageListingPricePercentage(mappedListing),
      });
    });
  }

  static mapToBoundaries(listings) {
    return listings.reduce((acc, { lon, lat }) => {
      if (acc[MapBoundsProperty.MinLat] > lat) {
        acc[MapBoundsProperty.MinLat] = lat;
      }

      if (acc[MapBoundsProperty.MaxLat] < lat) {
        acc[MapBoundsProperty.MaxLat] = lat;
      }

      if (acc[MapBoundsProperty.MinLon] > lon) {
        acc[MapBoundsProperty.MinLon] = lon;
      }

      if (acc[MapBoundsProperty.MaxLon] < lon) {
        acc[MapBoundsProperty.MaxLon] = lon;
      }

      return acc;
    }, {
      [MapBoundsProperty.MinLat]: Infinity,
      [MapBoundsProperty.MaxLat]: -Infinity,
      [MapBoundsProperty.MinLon]: Infinity,
      [MapBoundsProperty.MaxLon]: -Infinity,
    });
  }

  static #getAverageListingPricePercentage(listing) {
    if (listing.soldPrice && listing.listPrice) {
      const averagePercentage = (listing.soldPrice / listing.listPrice) * DEFAULT_PERCENTAGE;

      return `${Math.round(averagePercentage)}%`;
    }

    return null;
  }

  static #getFormattedDate(datetime, format) {
    return formatDatetime({
      datetime,
      format,
    });
  }
}

export default ListingsMapper;
